function kebabcase(value) {
  if (value) {
    return value.toLowerCase().replace(/[^a-z0-9\s-]/g, '').trim().replace(/[\s]+/g, '-');
  }

  return '';
}



export default kebabcase;
